export const LOGIN = "/login";
export const SMC = "/classifier";
export const SEE = "/entities";
export const CORPUS_LINK = "corpus";
export const MARKS_LINK = "marks";
export const SPR = "/recognizer";
export const TRANSCRIPT = "transcript";
export const SBS = "/biometry";
export const TTS = "/synthesis";
export const QAS = "/questionnaire";
export const INTERACTIVE = "interactive";
export const QUESTION = "question";
export const SES = "/robots";
export const CLS = "/calling-line";
export const RES = "/reports";
export const USERS = "/users";
export const ROLES = "roles";

export const SMC_CORPUS = `${SMC}/${CORPUS_LINK}`;
export const SMC_MARKS = `${SMC}/${MARKS_LINK}`;

export const SEE_CORPUS = `${SEE}/${CORPUS_LINK}`;

export const SPR_TRANSCRIPT = `${SPR}/${TRANSCRIPT}`;

export const QAS_QUESTION = `${QAS}/${QUESTION}`;
export const QAS_INTERACTIVE = `${QAS}/${INTERACTIVE}`;

export const USER_ROLES = `${USERS}/${ROLES}`;
